import en from './strings.en';

const ru = {
    participant: 'участник',
    invited: 'Приглашён',
    empty: 'нет уч.',
    participantCount: '{{count}} уч.',
    selectedFirmsAreApplicants: 'Все выбранные фирмы уже\nприглашены или есть на этой площадке',
    selectedFirmAreApplicants: 'Выбранная фирма уже приглашена на эту площадку',
    lackOfRights: 'У вашего контакта недостаточно прав для приглашения на эту площадку',
    invitedFirmsCount: {
        zero: '{{count}} фирм уже приглашено на площадку.',
        one: '{{count}} фирма уже приглашена на площадку.',
        few: '{{count}} фирмы уже приглашены на площадку.',
        many: '{{count}} фирм уже приглашены на площадку.',
        other: '{{count}} фирм уже приглашены на площадку.'
    },
    firmsToBeInvitedCount: 'Пригласим {{count}} {{firmPlural}}'
};

export default { ru, en: { ...ru, ...en} };
